export const USER_SET_USER = 'USER_SET_USER';
export function setUser(user) {
  return {
    type: USER_SET_USER,
    data: {
      user
    }
  };
}
